import {Navigate,Outlet,Route,Routes,useLocation} from "react-router-dom";
import {useEffect} from "react";
import {useQuery} from "@tanstack/react-query";
import i18n from "./i18n";
import {api} from "./api";
import type {Locale,UserSession} from "./types";
import {EntryPage} from "./pages/EntryPage";
import {NearbyPage} from "./pages/NearbyPage";
import {WomanPage} from "./pages/WomanPage";
import {MatchPage} from "./pages/MatchPage";
import {MessagesPage} from "./pages/MessagesPage";
import {ChatPage} from "./pages/ChatPage";
import {LikesPage} from "./pages/LikesPage";
import {AccountPage} from "./pages/AccountPage";
import {WelcomeNearbyPage} from "./pages/WelcomeNearbyPage";
import {AdminPage} from "./pages/AdminPage";
import {NativeShell} from "./components/NativeShell";
import {MessageRealtimeBridge} from "./components/MessageRealtimeBridge";

export function useLocale():Locale{const {pathname}=useLocation();return pathname.startsWith("/vn/")||pathname==="/vn"?"vn":"en";}
export function useSession(){return useQuery({queryKey:["session"],queryFn:()=>api<{user:UserSession|null}>("/session")});}

function LocaleShell(){
  const lang=useLocale();
  useEffect(()=>{void i18n.changeLanguage(lang);document.documentElement.lang=lang==="vn"?"vi":"en";localStorage.setItem("dating_lang",lang);},[lang]);
  return <><NativeShell/><Routes>
    <Route path="start" element={<EntryPage/>}/>
    <Route element={<Protected/>}>
      <Route path="welcome" element={<WelcomeNearbyPage/>}/>
      <Route path="nearby" element={<NearbyPage/>}/>
      <Route path="women/:womanId" element={<WomanPage/>}/>
      <Route path="match/:womanId/:conversationId" element={<MatchPage/>}/>
      <Route path="messages" element={<MessagesPage/>}/>
      <Route path="chat/:conversationId" element={<ChatPage/>}/>
      <Route path="likes" element={<LikesPage/>}/>
      <Route path="discover" element={<Navigate to="../likes" replace/>}/>
      <Route path="account" element={<AccountPage/>}/>
    </Route>
    <Route index element={<Navigate to="start" replace/>}/>
    <Route path="*" element={<Navigate to="start" replace/>}/>
  </Routes></>;
}

function EnglishRedirect(){
  const location=useLocation();
  const path=location.pathname.replace(/^\/zh(?=\/|$)/,"/en");
  return <Navigate to={`${path}${location.search}${location.hash}`} replace/>;
}

function Protected(){
  const lang=useLocale();const location=useLocation();const session=useSession();
  if(session.isLoading)return <div className="app-loader"><span/></div>;
  if(!session.data?.user)return <Navigate to={`/${lang}/start`} state={{from:location.pathname}} replace/>;
  return <><MessageRealtimeBridge/><Outlet/></>;
}

export default function App(){
  return <Routes>
    <Route path="/admin/*" element={<AdminPage/>}/>
    <Route path="/en/*" element={<LocaleShell/>}/>
    <Route path="/vn/*" element={<LocaleShell/>}/>
    <Route path="/zh/*" element={<EnglishRedirect/>}/>
    <Route path="*" element={<Navigate to="/en/start" replace/>}/>
  </Routes>;
}
